var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Icons/Basic/Messages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,8.6308245 L2,14 L14,14 L14,8.6308245 L9.06707354,11.7426354 C8.41513044,12.153897 7.58486956,12.153897 6.93292646,11.7426354 L2,8.6308245 Z M13.732641,6.79948109 L8,2.50000205 L2.26735898,6.79948109 L8,10.4157715 L13.732641,6.79948109 Z M0.400000154,5.7 L7.40000015,0.450002112 C7.75555565,0.1833356 8.24444435,0.1833356 8.59999985,0.450002112 L15.5999998,5.7 C15.8518058,5.88885438 16,6.18524275 16,6.50000012 L16,15 C16,15.5522847 15.5522847,16 15,16 L1,16 C0.44771525,16 -1.41432193e-14,15.5522847 -1.42108547e-14,15 L-1.38777878e-14,6.50000012 C-1.39163345e-14,6.18524275 0.148194221,5.88885438 0.400000154,5.7 Z",
    id: "Shape",
    fill: "#72809D",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.24b0f856cff1cf7be166d55e11c9baff.svg";
export { ForwardRef as ReactComponent };